import { PROCESS_STEPS, VIDEO } from '../../lib/constants';

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="section-pad bg-brand-bgElev text-brand-cream relative overflow-hidden border-y border-brand-gold/10"
    >
      <div
        aria-hidden
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-30"
        style={{ background: 'radial-gradient(circle, rgba(201,169,110,0.4) 0%, transparent 70%)' }}
      />
      <div className="container-prep relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <p className="eyebrow mb-5">What to Expect</p>
          <h2 className="heading-2 mb-6">
            What happens during
            <span className="italic block text-brand-gold">a lash lift at Prép?</span>
          </h2>
          <p className="text-brand-muted leading-relaxed mb-8">
            Every appointment is unhurried, intentional, and tailored to your
            lashes. Here's exactly what to expect from your 75 minutes with us.
          </p>
          <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-brand-gold/25">
            <video
              src={VIDEO.process.src}
              aria-label={VIDEO.process.alt}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
              data-testid="process-video"
            />
            <div className="absolute top-4 left-4 px-3 py-1.5 bg-brand-bg/80 backdrop-blur-md text-[10px] uppercase tracking-[0.22em] rounded-full text-brand-gold border border-brand-gold/30">
              Live · YUMI Treatment
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="space-y-2">
            {PROCESS_STEPS.map((step, i) => (
              <li
                key={step.n}
                data-testid={`process-step-${i + 1}`}
                className="group relative grid grid-cols-[auto_1fr] gap-6 sm:gap-8 px-6 sm:px-8 py-8 rounded-2xl border border-brand-gold/10 hover:border-brand-gold/40 hover:bg-brand-bgSoft transition-all"
              >
                <div className="font-serif text-5xl sm:text-6xl text-brand-gold/40 leading-none group-hover:text-brand-gold transition-colors">
                  {step.n}
                </div>
                <div>
                  <div className="flex items-baseline justify-between gap-3 mb-2">
                    <h3 className="font-serif text-2xl sm:text-3xl text-brand-cream">
                      {step.title}
                    </h3>
                    <span className="text-[10px] uppercase tracking-[0.22em] text-brand-gold whitespace-nowrap">
                      {step.duration}
                    </span>
                  </div>
                  <p className="text-brand-muted leading-relaxed">{step.body}</p>
                </div>
              </li>
            ))}
          </ol>
          <p className="mt-10 text-center text-brand-muted italic font-serif text-xl">
            You'll leave with visibly lifted, curled, darker lashes — and no makeup required.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Process;
